import { render, staticRenderFns } from "./ShareAllotmentCreateForm.vue?vue&type=template&id=11558ddd&"
import script from "./ShareAllotmentCreateForm.vue?vue&type=script&lang=js&"
export * from "./ShareAllotmentCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports